import { Container, Grid, makeStyles } from "@material-ui/core";
import React from "react";
import ProcessListSimple from "./collection/ListSimple";
import MenuBar from "../../layouts/dashboard/MenuBar";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(10),
    marginBottom: 100,
  },
}));

export default function Process( props ) {

  const classes = useStyles();

  return (
    <React.Fragment>  
      <MenuBar/>
      <Container component="main" maxWidth="md">
        <Grid container className={classes.paper} >
          <Grid item xs={12}>
            <ProcessListSimple/>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );

};
